"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState, useEffect } from "react";
import { ApiWaveMetadataType } from "@/generated/models/ApiWaveMetadataType";
import type { CreateDropMetadataType } from "./CreateDropContent";
import { Tooltip } from "react-tooltip";
interface CreateDropMetadataRowProps {
  readonly metadata: CreateDropMetadataType;
  readonly isError: boolean;
  readonly errorMessage: string | null;
  readonly index: number;
  readonly disabled: boolean;
  readonly onChangeKey: (params: {
    index: number;
    newKey: string;
  }) => void;
  readonly onChangeValue: (params: {
    index: number;
    newValue: string | number | null;
  }) => void;
  readonly onRemove: (index: number) => void;
}
const CreateDropMetadataRow: React.FC<CreateDropMetadataRowProps> = t0 => {
  const $ = _c(56);
  const {
    metadata,
    index,
    onChangeKey,
    onChangeValue,
    isError,
    errorMessage,
    onRemove,
    disabled
  } = t0;
  const [tempValue, setTempValue] = useState(metadata.value !== null ? String(metadata.value) : "");
  let t1;
  let t2;
  if ($[0] !== metadata.value) {
    t1 = () => {
      setTempValue(metadata.value !== null ? String(metadata.value) : "");
    };
    t2 = [metadata.value];
    $[0] = metadata.value;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== index || $[4] !== onChangeKey) {
    t3 = e => {
      onChangeKey({
        index,
        newKey: e.target.value
      });
    };
    $[3] = index;
    $[4] = onChangeKey;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const handleKeyChange = t3;
  let t4;
  if ($[6] !== index || $[7] !== metadata.type || $[8] !== onChangeValue) {
    t4 = e_0 => {
      const newValue = e_0.target.value;
      if (metadata.type === "NUMBER") {
        if (newValue === "" || newValue === "-" || /^-?\d*\.?\d*$/.test(newValue)) {
          setTempValue(newValue);
          if (newValue === "" || newValue === "-") {
            onChangeValue({
              index,
              newValue: null
            });
          } else {
            const numValue = parseFloat(newValue);
            onChangeValue({
              index,
              newValue: numValue
            });
          }
        }
      } else {
        setTempValue(newValue);
        onChangeValue({
          index,
          newValue
        });
      }
    };
    $[6] = index;
    $[7] = metadata.type;
    $[8] = onChangeValue;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const handleValueChange = t4;
  const isInputDisabled = disabled || metadata.required;
  const hasKeyError = !!errorMessage;
  let keyInputStateClasses = "tw-bg-iron-900 tw-pl-3 tw-text-iron-50 tw-ring-iron-700 focus:tw-bg-iron-950 focus:tw-outline-none focus:tw-ring-primary-400";
  if (isInputDisabled) {
    keyInputStateClasses = "tw-cursor-not-allowed tw-bg-iron-800 tw-pl-9 tw-text-iron-400 tw-ring-iron-700 focus:tw-ring-iron-700";
  } else {
    if (hasKeyError) {
      keyInputStateClasses = "tw-bg-iron-900 tw-pl-3 tw-text-iron-50 tw-ring-red focus:tw-bg-iron-950 focus:tw-outline-none focus:tw-ring-red";
    }
  }
  const t5 = isInputDisabled ? undefined : handleKeyChange;
  const t6 = `tw-form-input tw-block tw-w-full tw-rounded-lg tw-border-0 tw-text-base tw-font-normal tw-leading-6 tw-caret-primary-400 tw-shadow-sm tw-ring-1 tw-ring-inset tw-transition tw-duration-300 tw-ease-out placeholder:tw-text-iron-500 focus:tw-ring-1 focus:tw-ring-inset sm:tw-text-md ${keyInputStateClasses} tw-py-2.5`;
  let t7;
  if ($[10] !== disabled || $[11] !== isInputDisabled || $[12] !== metadata.key || $[13] !== t5 || $[14] !== t6) {
    t7 = <input type="text" placeholder="Key" value={metadata.key} onChange={t5} readOnly={isInputDisabled} disabled={disabled} className={t6} />;
    $[10] = disabled;
    $[11] = isInputDisabled;
    $[12] = metadata.key;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== metadata.required || $[17] !== metadata.type) {
    t8 = metadata.required && (metadata.type === ApiWaveMetadataType.Number ? <svg className="tw-absolute tw-left-3 tw-top-[15px] tw-size-3.5 tw-flex-shrink-0 tw-text-iron-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512" aria-hidden="true"><path fill="currentColor" d="M160 64c0-11.8-6.5-22.6-16.9-28.2s-23-5-32.8 1.6l-96 64C-.5 111.2-4.4 131 5.4 145.8s29.7 18.7 44.4 8.9L96 123.8V416H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96 96c17.7 0 32-14.3 32-32s-14.3-32-32-32H160V64z" /></svg> : <svg className="tw-absolute tw-left-3 tw-top-3.5 tw-size-4 tw-flex-shrink-0 tw-text-iron-400" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M4 7C4 6.06812 4 5.60218 4.15224 5.23463C4.35523 4.74458 4.74458 4.35523 5.23463 4.15224C5.60218 4 6.06812 4 7 4H17C17.9319 4 18.3978 4 18.7654 4.15224C19.2554 4.35523 19.6448 4.74458 19.8478 5.23463C20 5.60218 20 6.06812 20 7M9 20H15M12 4V20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>);
    $[16] = metadata.required;
    $[17] = metadata.type;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t7 || $[20] !== t8) {
    t9 = <div className="tw-relative tw-w-full">{t7}{t8}</div>;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  const t10 = metadata.type === ApiWaveMetadataType.Number ? "numeric" : "text";
  const t11 = disabled ? undefined : handleValueChange;
  const t12 = `tw-form-input tw-block tw-w-full tw-rounded-lg tw-border-0 tw-bg-iron-900 tw-text-base tw-font-normal tw-text-iron-50 tw-caret-primary-400 tw-shadow-sm tw-ring-1 tw-ring-inset sm:tw-text-md ${isError ? "tw-bg-iron-950 tw-ring-red hover:tw-ring-red focus:tw-ring-red" : "tw-ring-iron-700 hover:tw-ring-iron-700 focus:tw-ring-primary-400"} tw-py-2.5 tw-pl-3 tw-text-base tw-leading-6 tw-transition tw-duration-300 tw-ease-out placeholder:tw-text-iron-500 focus:tw-bg-iron-950 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset sm:tw-text-md ${disabled ? "tw-cursor-not-allowed tw-opacity-50" : ""}`;
  let t13;
  if ($[22] !== disabled || $[23] !== t10 || $[24] !== t11 || $[25] !== t12 || $[26] !== tempValue) {
    t13 = <div className="tw-w-full"><input type="text" inputMode={t10} placeholder="Value" value={tempValue} onChange={t11} readOnly={disabled} disabled={disabled} className={t12} /></div>;
    $[22] = disabled;
    $[23] = t10;
    $[24] = t11;
    $[25] = t12;
    $[26] = tempValue;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t13 || $[29] !== t9) {
    t14 = <div className="tw-flex tw-w-full tw-items-center tw-gap-x-3 tw-gap-y-2">{t9}{t13}</div>;
    $[28] = t13;
    $[29] = t9;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== index || $[32] !== onRemove) {
    t15 = () => onRemove(index);
    $[31] = index;
    $[32] = onRemove;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  const t16 = metadata.required ? "Required field" : "Remove";
  const t17 = disabled || metadata.required;
  const t18 = `tw-group -tw-ml-2 tw-flex tw-items-center tw-justify-center tw-rounded-full tw-border-0 tw-bg-transparent tw-p-2 tw-text-xs tw-font-medium tw-transition tw-duration-300 tw-ease-out ${disabled || metadata.required ? "tw-cursor-not-allowed tw-text-iron-600" : "tw-text-iron-400 hover:tw-text-error"}`;
  const t19 = `metadata-action-${metadata.id}`;
  let t20;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="tw-size-4"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" /></svg>;
    $[34] = t20;
  } else {
    t20 = $[34];
  }
  let t21;
  if ($[35] !== t15 || $[36] !== t16 || $[37] !== t17 || $[38] !== t18 || $[39] !== t19) {
    t21 = <div><button type="button" onClick={t15} aria-label={t16} disabled={t17} className={t18} data-tooltip-id={t19}>{t20}</button></div>;
    $[35] = t15;
    $[36] = t16;
    $[37] = t17;
    $[38] = t18;
    $[39] = t19;
    $[40] = t21;
  } else {
    t21 = $[40];
  }
  const t22 = `metadata-action-${metadata.id}`;
  let t23;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = {
      backgroundColor: "#1F2937",
      color: "white",
      padding: "4px 8px"
    };
    $[41] = t23;
  } else {
    t23 = $[41];
  }
  const t24 = metadata.required ? "Required field" : "Remove";
  let t25;
  if ($[42] !== t22 || $[43] !== t24) {
    t25 = <Tooltip id={t22} style={t23}>{t24}</Tooltip>;
    $[42] = t22;
    $[43] = t24;
    $[44] = t25;
  } else {
    t25 = $[44];
  }
  let t26;
  if ($[45] !== t21 || $[46] !== t25) {
    t26 = <>{t21}{t25}</>;
    $[45] = t21;
    $[46] = t25;
    $[47] = t26;
  } else {
    t26 = $[47];
  }
  let t27;
  if ($[48] !== t14 || $[49] !== t26) {
    t27 = <div className="tw-flex tw-w-full tw-items-center tw-gap-x-3">{t14}{t26}</div>;
    $[48] = t14;
    $[49] = t26;
    $[50] = t27;
  } else {
    t27 = $[50];
  }
  let t28;
  if ($[51] !== errorMessage) {
    t28 = errorMessage && <div className="tw-pl-1 tw-pt-1 tw-text-xs tw-font-medium tw-text-error">{errorMessage}</div>;
    $[51] = errorMessage;
    $[52] = t28;
  } else {
    t28 = $[52];
  }
  let t29;
  if ($[53] !== t27 || $[54] !== t28) {
    t29 = <div className="tw-w-full">{t27}{t28}</div>;
    $[53] = t27;
    $[54] = t28;
    $[55] = t29;
  } else {
    t29 = $[55];
  }
  return t29;
};
export default CreateDropMetadataRow;